export const getBorderExtension = (theme, side) => `
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    ${side}: -${theme.borderWidth['200']};
    width: ${theme.borderWidth['200']};
    height: 100vh;
    background-color: ${theme.color['fill-info-default']};
    pointer-events: none;
    z-index: 3;
  }
`;